<template>
  <el-dialog title="商品批次"
             :visible.sync="visible"
             width="640px"
             @close='handleClose'
             append-to-body=""
             :close-on-press-escape="false">
    <el-table border
              ref="table"
              row-key="batchId"
              v-loading="loading"
              @selection-change="handleSelectionChange"
              :data="list">
      <el-table-column type="selection"
                       :reserve-selection="true"
                       width="55">
      </el-table-column>
      <el-table-column label="商品批次号"
                       width="140"
                       prop="batchCode">
      </el-table-column>
      <el-table-column label="商品名称"
                       prop="productName">
        <template slot-scope="{row}">
          {{row.productName}}<span v-if="row.productNameRemark">({{row.productNameRemark}})</span>
        </template>
      </el-table-column>
      <el-table-column label="商品数量"
                       width="100"
                       prop="goodsCount">
      </el-table-column>
      <el-table-column label="创建时间"
                       width="100">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD')}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   @current-change="handleCurrentChange"
                   :current-page.sync="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
                 :loading="loading">取消</el-button>
      <el-button type="primary"
                 @click="submit"
                 :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'associate-batch-modal',
  components: {},
  props: {
    selected: {
      type: Array,
      default () {
        return []
      }
    },
    option: {
      type: Object,
      default () {
        return {
          vendorId: '',
          tradeType: '',
          productIds: null
        }
      }
    }
  },
  data () {
    return {
      inited: true,
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      multipleSelection: []
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  watch: {
    'option.productIds' (v) {
      this.inited = true
      this.config.pageNum = 1
      this.$refs.table && this.$refs.table.clearSelection()
    },
    visible (val, oldVal) {
      if (val) {
        if (this.inited) {
          this.inited = false
          this.$nextTick(() => {
            this.selected.forEach(item => {
              this.$refs.table.toggleRowSelection(item, true)
            })
            this.fetchList()
          })
        }
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () { },
    reset (ret) {
      console.log('reset', ret)
      if (!this.inited) {
        this.config.pageNum = 1
        this.total = 0
        this.list = []
        this.$refs.table.clearSelection()
        this.inited = true
      }
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('batch/getbatchs', {
        payload: {
          canAssociateInspectReport: this.userPermission.OPERATE ? null : 1,
          ...this.config,
          ...this.option
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submit () {
      this.$emit('update:selection', this.multipleSelection)
      this.toggleModal(false)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val // 勾选放在multipleSelection数组中
    }
  },
  created () { },
  mounted () {
    // this.fetchList()
  }
}
</script>
<style lang="stylus" scoped></style>
